<template>
    <div :class="$style['home-category']">
        <div style="width: 100%;">
            <div :class="$style['home-header']" v-if="!search_open">
                <span>محصولات</span>
            </div>
        </div>
        <div>
            <v-tabs
                    v-model="tabs"
                    fixed-tabs color="gray" style="font-size: 11px; font-weight: bold">
                <v-tab
                        style="font-size: 11px; font-weight: bold"
                        v-for="n in items"
                        :key="n">
                    {{ n }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div :class="$style['mediaSection']" v-for="(cat, index) in AllitemCat" :key="index">
                                <div :class="$style['titleMore']">
                                    <h5 class="font-weight-bold">{{cat.category_name}}</h5>
                                    <div :class="$style['showMore']">
                                        <router-link
                                                :to="{name: 'CatProducts',
                    query: {id: cat.category_id, pname: cat.category_name, categories : true}}">
                                            <span style="color: #7ec352; font-size: 12px">مشاهده همه</span>
                                            <v-icon style="color: #7ec352; font-size: 12px">chevron_left</v-icon>
                                        </router-link>
                                    </div>
                                </div>
                                <div :class="$style['story']">
                                    <v-col class="d-flex flex-column"  style="margin-left: 5px; margin-right: 5px; align-items: center;" cols="3"
                                           v-for="(item, index) in cat.children" :key="index">
                                            <div :class="$style['itemStory']"
                                                 role="button" v-ripple @click="showStory(item.category_id, item.category_name, cat.category_name)">
                                                <img :src="item.category_cover" :alt="item.category_name"/>
                                            </div>
                                            <div :class="$style['titleName']">
                                                <span>{{ item.category_name }}</span>
                                            </div>
                                    </v-col>
                                </div>
                            </div>
                            <div style="height: 100px"></div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <div style="height: 100px"></div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                            <ProductList :list="favoriteList"></ProductList>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>

        <div :class="$style['button-basket-css']">
            <div :class="$style['button-basket-sub']">
                <v-btn role="button" v-ripple @click="goBasket">
                    <v-icon>shopping_cart</v-icon>
                </v-btn>
                <p v-if="num_basket != null && num_basket != 0">{{num_basket}}</p>
            </div>
        </div>

    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import * as $swal from "sweetalert2";
    import ProductList from "@/pages/ProductList";

    export default {
        name: "Categories",
        components: {
            ProductList
        },
        data() {
            return {
                favoriteList: [],
                search_open: false,
                items: ['دسته بندی ها', 'ویژه ها', 'محبوب من'],
                tabs: null,
                AllitemCat: [],
                num_basket: null,
            };
        },
        methods: {
            showStory(id, Pname, Catname) {
                this.$router.push({
                    name: 'CatProducts',
                    query: {id: id, pname: Pname, cname: Catname, shop_id: this.$route.query.id}
                })
            },
            goBasket() {
                this.$router.push({name: 'Basket'})
            },
        },
        mounted() {
            this.num_basket = oracle.getCount()
            oracle.axios(
                "productCategory/getList",
                {"limit_by": 500, "offset_by": 0, "order_by": "priority"},
                (res) => {
                    this.AllitemCat = res.data;
                }
            );
            oracle.axios('product/getFavorites', {"limit_by": 500, "offset_by": 0, "order_by": "priority"}
                , (res) => {
                    this.favoriteList = res.data;
                })
        },
    };
</script>
<style module>
    .home-category {
        height: 100%;
        overflow: scroll;
    }

    .home-category a {
        text-decoration: none;
    }

    .home-header {
        display: flex;
        justify-content: space-between;
        background-color: #dbdada;
        height: 45px
    }

    .home-header span {
        width: 100%;
        display: flex;
        justify-content: space-between;
        background-color: #dbdada;
        height: 45px;
        align-items: center;
        margin-right: 15px
    }

    .home-header-search {
        display: flex;
        justify-content: space-between;
        height: 40px
    }

    .titleMore {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 5px;
    }

    .titleMore h5 {
        font-size: 15px;
        font-weight: bold;
    }

    .story {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        overflow: auto;
    }

    .itemStory {
        width: 70px;
        height: 70px;
        border-radius: 120px;
        overflow: hidden;
    }

    .itemStory img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .titleName {
        text-align: center;
        font-size: 13px;
        margin-top: 10px;
    }


    .button-basket-css {
        text-align: left;
    }

    .button-basket-sub button {
        margin-bottom: 75px;
        position: fixed;
        bottom: 0;
        left: 25px;
        border-radius: 50%;
        background-color: #7ec352 !important;
        color: white !important;
        display: block !important;
        height: 54px !important;
        min-width: 54px !important;
    }

    .button-basket-sub p {
        background-color: #cc7540;
        position: fixed;
        bottom: 97px;
        left: 60px;
        border-radius: 50%;
        width: 25px;
        text-align: center;
        color: white;
        font-size: 12px;
        height: 25px;
        line-height: 25px;
    }
</style>
